<template>
  <DefaultLayout>
    <Body class="page-404" />

    <section class="section">
      <!-- 404 -->
      <div class="wrap not-found">
        <div class="text">
          <h1 class="title">
            {{ $t('요청하신페이지를찾을수없습니다') }}
          </h1>
          <div class="desc">
            {{ $t('주소가잘못입력되었거나변경혹은삭제되어페이지를찾을수없습니다') }}
          </div>
        </div>
        <div class="btns">
          <a href="javascript:history.back();" class="btn">{{ $t('뒤로가기') }}</a>
          <a href="/" class="btn style-filled">{{ $t('홈') }}</a>
        </div>
      </div>
    </section>
  </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from '~/layouts/default.vue'

const { $t } = useNuxtApp()

const error = useError()

console.log(error.value)

// Head,Body
useHead({
  title: `Page not found - ${$t('어머니사랑과평화의날캠페인')}`,
})
</script>
